import React from "react";
import ClassStudentFeeSummary from "./ClassStudentFeeSummary";

const TotalFee = () => (
  <ClassStudentFeeSummary
    title="Total Fee"
    metricKey="total_fee"
    metricLabel="Total Fee"
    accentColor="#f97316"
    showOnlyPositive
  />
);

export default TotalFee;
